import { WidgetSize } from '@wix/wix-chatbot-common/browser';

import type { TRootState } from '../reducers';

export const selectWidgetSize = ({ widget }: TRootState): WidgetSize => widget.size;
export const selectWidgetExpanded = ({ widget }: TRootState): boolean => widget.expanded;
